var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './TooltipGraph.styles.scss';
var TooltipGraph = function (_a) {
    var active = _a.active, payload = _a.payload, label = _a.label, formatter = _a.formatter;
    if (active && payload && payload.length) {
        return (_jsxs("div", __assign({ className: "recharts-custom-tooltip", role: "tooltip" }, { children: [label && _jsx("p", __assign({ className: "recharts-tooltip-label" }, { children: label })), _jsx("ul", __assign({ className: "recharts-tooltip-item-list" }, { children: payload.map(function (item, idx) {
                        var _a, _b, _c, _d;
                        return (_jsxs("li", __assign({ style: {
                                color: ((_a = item === null || item === void 0 ? void 0 : item.style) === null || _a === void 0 ? void 0 : _a.stroke) ||
                                    ((_b = item === null || item === void 0 ? void 0 : item.style) === null || _b === void 0 ? void 0 : _b.fill) ||
                                    ((_c = item === null || item === void 0 ? void 0 : item.payload) === null || _c === void 0 ? void 0 : _c.style.stroke) ||
                                    ((_d = item === null || item === void 0 ? void 0 : item.payload) === null || _d === void 0 ? void 0 : _d.style.fill),
                            } }, { children: [item.name, ": ", formatter ? formatter(item.value) : item.value] }), idx));
                    }) }))] })));
    }
    return null;
};
export default TooltipGraph;
